import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(response.data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (location.hash?.includes("session_id=")) { setLoading(false); return; }
    const staffRoute = location.pathname.startsWith("/admin") || location.pathname.startsWith("/dashboard");
    if (!staffRoute) { setLoading(false); return; }
    setLoading(true);
    checkAuth();
  }, [checkAuth, location.hash, location.pathname]);

  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const loginWithPassword = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    setUser(response.data);
    return response.data;
  };
  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setUser(null);
  };
  return <AuthContext.Provider value={{ user, loading, setUser, checkAuth, startGoogleLogin, loginWithPassword, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);